import { schedularAnnouncementActions } from './../../actions/constant';

const {
  GET_ALL_ANNOUNCEMENTS_REQUEST,
  GET_ALL_ANNOUNCEMENTS_SUCCESS,
  GET_ALL_ANNOUNCEMENTS_FAILURE,
  GET_ALL_ANNOUNCEMENTS_RESET,
} = schedularAnnouncementActions;

const initialState: object = {
  response: null,
  loading: false,
};
export const getAllAnnouncementReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ALL_ANNOUNCEMENTS_REQUEST: {
      return { ...state, response: null, loading: true };
    }

    case GET_ALL_ANNOUNCEMENTS_SUCCESS: {
      return { ...state, response: action.payload, loading: false };
    }

    case GET_ALL_ANNOUNCEMENTS_FAILURE: {
      return { ...state, response: action.payload, loading: false };
    }

    case GET_ALL_ANNOUNCEMENTS_RESET:
      return initialState;

    default:
      return state;
  }
};
